import { Info } from "lucide-react";

export function PrivacyBanner({ compact = false }: { compact?: boolean }) {
  return (
    <div
      className={
        compact
          ? "w-full max-w-xl border rounded-lg bg-muted/40 px-3 py-2 text-[12px] text-muted-foreground"
          : "w-full max-w-2xl border rounded-xl bg-muted/40 px-4 py-3 text-sm text-muted-foreground"
      }
      role="note"
      aria-label="Privacy mantra"
    >
      <div className="flex items-start gap-2">
        <Info className="w-4 h-4 shrink-0 text-primary mt-0.5" />
        <div>
          <span className="font-semibold text-foreground">
            For you, not about you.
          </span>{" "}
          We process encounters to give <em>you</em> private feedback. Nothing
          is shared to leadership dashboards.
        </div>
      </div>
    </div>
  );
}
